import { render, staticRenderFns } from "./AvatarUpload.vue?vue&type=template&id=0be4c76b&scoped=true&lang=pug&"
import script from "./AvatarUpload.vue?vue&type=script&lang=js&"
export * from "./AvatarUpload.vue?vue&type=script&lang=js&"
import style0 from "./AvatarUpload.vue?vue&type=style&index=0&id=0be4c76b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be4c76b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
